import { Action, createReducer, on } from '@ngrx/store';
import { LocalStorageService } from 'src/app/shared/localstorage.service';
import * as actions from './field-visibility.actions';
import {
  HiddenFieldsByModule,
  IFieldVisibilityCatalog,
} from './field-visibility.types';

export interface FieldVisibilityState {
  hiddenFields: HiddenFieldsByModule;
  catalog: IFieldVisibilityCatalog | null;
  catalogLoaded: boolean;
}

function emptyCatalog(): IFieldVisibilityCatalog {
  return {
    order: { system: [], custom: [] },
    product: { system: [], custom: [] },
    company: { system: [], custom: [] },
  };
}

function normalizeHidden(input: unknown): HiddenFieldsByModule {
  if (!input || typeof input !== 'object') return {};
  const out: HiddenFieldsByModule = {};
  for (const key of ['order', 'product', 'company'] as const) {
    const raw = (input as Record<string, unknown>)[key];
    if (Array.isArray(raw)) {
      out[key] = raw.filter((k): k is string => typeof k === 'string');
    }
  }
  return out;
}

const storedCurrentUser = LocalStorageService.get('currentUser');
const storedHiddenFields = normalizeHidden(storedCurrentUser?.user?.hidden_fields);

export const initialFieldVisibilityState: FieldVisibilityState = {
  hiddenFields: storedHiddenFields,
  catalog: null,
  catalogLoaded: false,
};

const fieldVisibilityFeatureReducer = createReducer(
  initialFieldVisibilityState,
  on(actions.loadHiddenFieldsFromLogin, (state, { hiddenFields }) => ({
    ...state,
    hiddenFields: normalizeHidden(hiddenFields),
  })),
  on(actions.clearHiddenFields, (state) => ({
    ...state,
    hiddenFields: {},
  })),
  on(actions.loadFieldVisibilityCatalogSuccess, (state, { catalog }) => ({
    ...state,
    catalog: catalog ?? emptyCatalog(),
    catalogLoaded: true,
  })),
  on(actions.loadFieldVisibilityCatalogFailure, (state) => ({
    ...state,
    catalogLoaded: true,
  }))
);

export function fieldVisibilityReducer(
  state: FieldVisibilityState | undefined,
  action: Action
): FieldVisibilityState {
  return fieldVisibilityFeatureReducer(state, action);
}
